/**
 * 页面信息配置文件
 * */
import KeepAlive from 'react-activation'
import asyncComponent from './asyncComponent';


const Home = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Home'));
const VinList = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Monitoring/VinList'));
const VinDetail = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Monitoring/VinDetail'));
const VinDistribution = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Monitoring/VinDistribution'));
const VinModel = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/MgtCenter/VinModel'));
const AddVInType = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Monitoring/components/AddVInType'));
const AddVin = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Monitoring/components/AddVin'));
const PositionMonitoring = asyncComponent(() => import(/* webpackChunkName: "monitoring" */'../containers/Monitoring/PositionMonitoring'));
const DeviceList = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/storage/DeviceList'));
const ExportTask = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/ExportTask'));
const AccStatistics = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/AccStatistics'));
const WorkTimeStatistics = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/WorkTimeStatistics'));
const AlarmStatistics = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/AlarmStatistics'));
const EngineTimeStatistics= asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/EngineTimeStatistics'));
const ForkliftStatistics = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/ForkliftStatistics'));
const FailureStatistics = asyncComponent(() => import(/* webpackChunkName: "storage" */'../containers/Statistics/FailureStatistics'));

const UserMgt = asyncComponent(() => import(/* webpackChunkName: "usecenter" */'../containers/UserCenter/UserMgt'));
const OrganizationConfig = asyncComponent(() => import(/* webpackChunkName: "usecenter" */'../containers/UserCenter/OrganizationConfig'));
const PermissionConfig = asyncComponent(() => import(/* webpackChunkName: "usecenter" */'../containers/UserCenter/PermissionConfig'));
const AddPermissionConfig = asyncComponent(() => import(/* webpackChunkName: "usecenter" */'../containers/UserCenter/components/AddPermissionConfig'));

const FenceManage = asyncComponent(() => import(/* webpackChunkName: "mgtcenter" */'../containers/MgtCenter/FenceManage'));
const PolygonalFence = asyncComponent(() => import(/* webpackChunkName: "mgtcenter" */'../containers/MgtCenter/PolygonalFence'));
const DirectivRecord = asyncComponent(() => import(/* webpackChunkName: "mgtcenter" */'../containers/MgtCenter/DirectiveRecord'));
const DirectiveTask = asyncComponent(() => import(/* webpackChunkName: "mgtcenter" */'../containers/MgtCenter/DirectiveTask'));

/*菜单层级只设计了两级，内部按钮对应的页面可以参考“新增车辆类型”菜单设计 notInMenu*/
const menus = [
    {
        title:Strings.home || "首页",//todo
        icon:'iconfont icon-jiankong',
        path:'panel',
        element: <Home/>,
        key:'1-1',
    },
    {
        title:Strings.monitor || "监控中心",//todo
        icon:'iconfont icon-jiankongzhongxin',
        path:'monitoring',
        key:'2',
        children:[

            {
                title:Strings.vinlist  || "车辆列表",
                path:'vinlist',
                element: <KeepAlive name={"vinlist"} id="vinlist"><VinList/></KeepAlive>,
                key:'2-1',
                name:"vinlist",//用于删除的标记
            },
            {
                title:Strings.vinDetail || "车辆详情",
                path:'vindetail',
                element:  <VinDetail/>,
                key:'2-2',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.vindistribution || "车辆分布",
                path:'vindistribution',
                element:  <KeepAlive name={"vindistribution"} id="vindistribution"><VinDistribution/></KeepAlive>,
                key:'2-3',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addCar || "新增车辆",
                path:'addvin',
                element: <AddVin/>,
                key:'2-4',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.vindistribution || "车辆分布",
                path:'positionmonitoring',
                element: <PositionMonitoring/>,
                key:'2-5',
            },

        ]
    },
    {
        title:Strings.dataCenter || "数据中心",//todo
        icon:'iconfont icon-shujuzhongxin',
        path:'store',
        key:'5',
        children:[
            {
                title:Strings.exportTask || "导出任务",
                path:'exporttask',
                element: <ExportTask/>,
                key:'5-1',
            },{
                title: Strings.workHourStatistics ||  "工时统计",
                path:'worktimestatistics',
                element: <KeepAlive name={"worktimestatistics"} ><WorkTimeStatistics/></KeepAlive>,
                key:'5-2',
                name:"worktimestatistics",
            }, {
                title:  Strings.accStatistics || "ACC统计",
                path:'accstatistics',
                element: <KeepAlive name={"accstatistics"} id="accstatistics"><AccStatistics/></KeepAlive>,
                key:'5-3',
            },
            {
                title:  Strings.alarmSys || "报警统计",
                path:'alarmstatistics',
                element: <AlarmStatistics/>,
                key:'5-4',
            },
            {//诺力叉车故障
                title:  Strings.ForkliftErorr || "叉车故障",
                path:'forkliftstatistics',
                element: <ForkliftStatistics/>,
                key:'5-6',
                isAuthMenu:true
            },
            {//诺力叉车故障
                title:  Strings.errorstatistics || "故障统计",
                path:'failurestatistics',
                element: <FailureStatistics/>,
                key:'5-7',
                isAuthMenu:true
            },
            // {
            //     title:  "发动机工作时长",
            //     path:'enginetimestatistics',
            //     element: <KeepAlive name={"enginetimestatistics"}><EngineTimeStatistics/></KeepAlive>,
            //     // element: <EngineTimeStatistics/>,
            //     name: 'enginetimestatistics',
            //     key:'5-5',
            // },
        ]
    },
    {
        title:Strings.storage || "库存中心",//todo
        icon:'iconfont icon-kucunzhongxin',
        path:'store',
        key:'3',
        children:[
            {
                title:Strings.deviceMgt || "设备管理",
                path:'devicelist',
                element:<DeviceList/>,
                key:'3-1',
            },
        ]
    },
    {
        title:Strings.userCenter || "用户中心",//todo
        icon:'iconfont icon-yonghuzhongxin',
        path:'usercenter',
        key:'6',
        children:[
            {
                title:Strings.userMgt || "用户管理",
                path:'orgMgt',
                element: <KeepAlive name={"usermgt"} id="usermgt"><UserMgt/></KeepAlive>,
                key:'6-1',
            },
            {
                title:Strings.userconfig  || "用户配置",
                path:'userconfig',
                element: <KeepAlive name={"userconfig"} id="userconfig"><OrganizationConfig /></KeepAlive>,
                key:'6-2',
            },
             {
                title:Strings.permissionconfig  || "权限配置",
                path:'permissionconfig',
                element: <PermissionConfig />,
                key:'6-3',
            },
             {
                title:Strings.addpermission || "新建权限",
                path:'addpermission',
                element: <AddPermissionConfig/>,
                key:'6-3-1',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
        ]
    },
    {
        title:Strings.mtgCenter || "管理中心",
        icon:'iconfont icon-guanlizhongxin',
        path:'store',
        key:'4',
        children:[
            {
                title:Strings.modelMgt || "车型管理",
                path:'vinmodel',
                element:  <VinModel/>,
                key:'4-1',
            },
            {
                title:Strings.addScissorlift || "新增剪叉车类型",
                path:'addScissorlift',
                element: <AddVInType/>,
                key:'4-1-1',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addForklift || "新增叉车类型",
                path:'addForklift',
                element: <AddVInType/>,
                key:'4-1-2',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addArmCar || "新增臂车类型",
                path:'addArmCar',
                element: <AddVInType/>,
                key:'4-1-3',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addCrawlerCrane || "新增履带起重机",
                path:'addCrawlerCrane',
                element: <AddVInType/>,
                key:'4-1-4',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addTruckCrane || "新增汽车起重机",
                path:'addTruckCrane',
                element: <AddVInType/>,
                key:'4-1-5',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addAllTerrainTruckCrane || "新增全地面汽车起重机",
                path:'addAllTerrainTruckCrane',
                element: <AddVInType/>,
                key:'4-1-6',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addMobileCrane || "新增随车吊",
                path:'addMobileCrane',
                element: <AddVInType/>,
                key:'4-1-7',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.addCrawlerCrane || "新增履带起重机",
                path:'addMobileCraneFromArm',
                element: <AddVInType/>,
                key:'4-1-8',
                notInMenu:true,//不显示在菜单中的隐藏页面
            },
            {
                title:Strings.fencemgt || "围栏管理",
                path:'fenceMgt',
                element: <FenceManage/>,
                key:'4-2',
            },
            {
                title:Strings.polygonalFence || "多边形围栏",
                path:'polygonalFence',
                element:  <PolygonalFence/>,
                key:'4-3',
            },
            {
                title:Strings.directivRecord || "指令日志",
                path:'directivRecord',
                element: <KeepAlive name={'directivRecord'}><DirectivRecord/></KeepAlive>,
                name: 'directivRecord',
                key:'4-4',
                notInMenu:true,
            },
            {
                title:Strings.directiveTask || "指令任务",
                path:'directiveTask',
                element: <KeepAlive name={'directiveTask'}><DirectiveTask/></KeepAlive>,
                name: 'directiveTask',
                key:'4-5',
            },
        ]
    }
];

export default { menus }
